import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Grid,
  Typography,
  Card,
  Autocomplete,
  FormControlLabel,
  Radio,
  RadioGroup,
  TableCell,
  TableBody,
  TableRow,
  Table,
  TableContainer,
  Checkbox,
} from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
import AddIcon from "@mui/icons-material/Add";

const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditVehicle() {
  const history = useHistory();
  let { id } = useParams();
  const data_params = { id: id };
  const EmpId = localStorage.getItem("EmpId");
  const classes = useStyles();
  const [MasterCost, setMasterCost] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [vender, setVender] = useState();
  const [venderData, setVenderData] = useState([]);

  const [VehicleStatus, setVehicleStatus] = useState(1);
  const [VehicleName, setVehicleName] = useState("");
  const [ownerType, setOwnerType] = useState("Owned");
  const [VehicleNo, setVehicleNo] = useState("");
  const [ModId, setModId] = useState("1");
  const [Submitting, setSubmitting] = useState(false);
  const [GroupData, setGroupData] = useState([]);
  const [GroupId, setGroupId] = useState("G001");
  const [ErrVehicleName, setErrVehicleName] = useState(false);
  const [ErrVehicleNo, setErrVehicleNo] = useState(false);
  const [rows, setRows] = useState([]);
  function addRow() {
    const newRow = {
      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
      CostId: "",
      CostPrice: 0,
      CurrencyId: "",
      CostPerContainer: true,
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e, id) => i !== id);
    setRows(data);
  };
  const getMasterCost = async () => {
    try {
      const res = await api.get(`/api/master/cost/Sale%20Order%20Cost`);
      setMasterCost(res?.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  const fetch_group = async () => {
    try {
      const res = await api.get("api/master/group");
      // console.log(res.data.data);
      setGroupData(res.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  const fetch_vender = async () => {
    try {
      const res = await api.get("api/vender/list");
      // console.log(res.data.data);
      const truckingOnly = (res.data || []).filter(
        (v) => v.VenderType === "Trucking Agent"
      );
      setVenderData(truckingOnly);
    } catch (e) {
      console.log(e);
    }
  };
  const getCurrency = async () => {
    try {
      const res = await api.get(`api/master/currency`);
      setCurrency(res?.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  const getData = async () => {
    try {
      const data = await api
        .post("api/vehicle/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            // console.log(response.data);
            [].concat(response.data).map((res) => {
              setVehicleName(res.VehicleName);
              setVehicleNo(res.VehicleNo);
              setModId(res.ModID);
              setGroupId(res.GroupId);
              setVender({
                VenderName: res.VehicleName,
                VenderId: res.VenderId
              })
              setRows(res.VehicleCostDetails)
              setOwnerType(res.OwnerType)
              // res.Status.data.map((res) => {
              //   setVehicleStatus(res);
              // });
              setVehicleStatus(res.Status === true ? 1 : 0);
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Vehicle");
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const addData = async () => {
    const data = {
      no: VehicleNo,
      name: vender?.VenderName,
      VenderId: vender?.VenderId,
      groupId: GroupId,
      status: VehicleStatus,
      createId: EmpId,
      OwnerType: ownerType,
      VehicleCostDetail: rows
    };

    if (!vender || !VehicleNo) {
      if (!vender) {
        setErrVehicleName(true);
      } else if (!VehicleNo) {
        setErrVehicleNo(true);
      }
    } else {
      api
        .post("api/vehicle/create", data)
        .then((respose) => {
          const MySwal = withReactContent(Swal);

          MySwal.fire({
            icon: "success",
            didOpen: () => {
              MySwal.clickConfirm();
            },
          }).then(() => {
            return MySwal.fire(
              "สำเร็จ!",
              "เพิ่มประเภทยานพาหนะ !",
              "success"
            ).then((result) => {
              if (result.isConfirmed) {
                history.push("/Setting/Vehicle");
              }
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // alert(JSON.stringify(data, null, 2));
    setSubmitting(false);
  };

  const editData = async () => {
    const data = {
      id: id,
      no: VehicleNo,
      name: vender?.VenderName,
      VenderId: vender?.VenderId,
      groupId: GroupId,
      status: VehicleStatus,
      createId: EmpId,
      OwnerType: ownerType,
      VehicleCostDetail: rows,
      ModId: EmpId,
      
    };

    if (!vender || !VehicleNo) {
      if (!vender) {
        setErrVehicleName(true);
      } else if (!VehicleNo) {
        setErrVehicleNo(true);
      }
    } else {
      api
        .post("api/vehicle/update", data)
        .then((respose) => {
          const MySwal = withReactContent(Swal);

          MySwal.fire({
            icon: "success",
            didOpen: () => {
              MySwal.clickConfirm();
            },
          }).then(() => {
            return MySwal.fire(
              "สำเร็จ!",
              "แก้ไขประเภทยานพาหนะ !",
              "success"
            ).then((result) => {
              if (result.isConfirmed) {
                history.push("/Setting/Vehicle");
              }
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // alert(JSON.stringify(data, null, 2));
    setSubmitting(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (id) {
      editData();
    } else {
      addData();
    }
  };

  useEffect(() => {
    if (id) {
      getData();
    }
    fetch_group();
    getMasterCost()
    fetch_vender()
    getCurrency()
  }, []);

  return (
    <div>
      <Card
        variant="outlined"
        style={{ padding: "20px", margin: "25px", height: "86vh" }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ยานพาหนะ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Vehicle
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Vehicle
            </Typography>
          </Grid>
        </Grid>

        <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
          {/* <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
            ยานพาหนะ
          </h6> */}

          <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
          <Grid item xs={12} sm={12} md={12}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={ownerType}
                  onChange={(e) => setOwnerType(e.target.value)}
                >
                  <FormControlLabel
                    value="Owned"
                    control={<Radio />}
                    label="Owned"
                  />
                  <FormControlLabel
                    value="Supplier"
                    control={<Radio />}
                    label="Supplier"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={venderData}
                style={{
                  width: "100%",
                }}
                value={vender || null}
                onChange={(x, y) => {setVender(y)}}
                getOptionLabel={(option) => option?.VenderName}
                renderInput={(params) => (
                  <TextField
                    name="customer_name"
                    label="Company / Vender Name"
                    variant="outlined"
                    placeholder="Company / Vender Name"
                    required
                    
                    InputLabelProps={{ shrink: true }}
                    classes={{ root: (ErrVehicleName || !vender) ? classes.customOutline : null }}

                    {...params}
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              {/* <TextField
                name="Code"
                label="Vender Code"
                variant="outlined"
                placeholder="Enter Vender Code"
                style={{
                  width: "100%",
                }}
                InputLabelProps={{ shrink: true }}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              {/* <TextField
                name="MAC5"
                label="MAC-5 Code "
                variant="outlined"
                placeholder="Enter MAC-5 Code "
                style={{
                  width: "100%",
                }}
                InputLabelProps={{ shrink: true }}
              /> */}
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Vehicle No."
                InputLabelProps={{ shrink: true }}
                placeholder="Enter Vehicle No."
                name="VehicleNo"
                style={{
                  width: "100%",
                }}
                onChange={(e) => {
                  setVehicleNo(e.target.value);
                  setErrVehicleNo(false);
                }}
                // onBlur={handleBlur}
                value={VehicleNo}
                error={ErrVehicleNo}
                classes={{ root: !VehicleNo ? classes.customOutline : null }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel id="select_status-label">Status</InputLabel>
                <Select
                  name="select_status"
                  id="select_status"
                  value={VehicleStatus}
                  label="Status"
                  style={{
                    width: "100%",
                  }}
                  onChange={(e) => setVehicleStatus(e.target.value)}
                >
                  <MenuItem value={1}>Active</MenuItem>
                  <MenuItem value={0}>InActive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              {/* <TextField
                name="Address"
                label="Address"
                variant="outlined"
                placeholder="Enter Address"
                style={{
                  width: "100%",
                }}
                InputLabelProps={{ shrink: true }}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="select_group">Group</InputLabel>
                <Select
                  name="select_Group"
                  id="select_Group"
                  value={GroupId}
                  label="Group"
                  style={{
                    width: "100%",
                  }}
                  onChange={(e) => setGroupId(e.target.value)}
                >
                  {GroupData.map((x) => (
                    <MenuItem value={x.GroupId}>{x.GroupName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              {/* <TextField
                name="Contact"
                label="Contact Name"
                variant="outlined"
                placeholder="Enter Contact Name"
                style={{
                  width: "100%",
                }}
                InputLabelProps={{ shrink: true }}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              {/* <TextField
                name="Email"
                label="Email"
                variant="outlined"
                placeholder="Enter Email"
                style={{
                  width: "100%",
                }}
                InputLabelProps={{ shrink: true }}
              /> */}
            </Grid>
            

            <Grid item xs={12} sm={6} md={3}>
              {/* <TextField
                name="Telephone"
                label="Telephone"
                variant="outlined"
                placeholder="Enter Telephone"
                style={{
                  width: "100%",
                }}
                InputLabelProps={{ shrink: true }}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              {/* <TextField
                    label="FREIGHT TERMS NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter FREIGHT TERMS NO."
                    name="f_t_no"
                    style={{
                      width: "40%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={(e) => setF_t_no(e.target.value)}
                    onBlur={handleBlur}
                    value={f_t_no}
                  />
                  {errors.f_t_no && touched.f_t_no && errors.f_t_no} */}
            </Grid>
          </Grid>
          <Button
            type="button"
            variant="contained"
            // disabled={costType ? false : true}
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginTop: "10px",
            }}
            onClick={addRow}
          >
            <AddIcon /> Add
          </Button>
          <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
            <Table stickyHeader>
              <TableRow>
                <TableCell align="center" width="5%">
                  #
                </TableCell>
                <TableCell align="center" width="15%">
                  Charge
                </TableCell>
                <TableCell align="center" width="10%">
                  Quantity
                </TableCell>
                <TableCell align="center" width="15%">
                  Price
                </TableCell>
                <TableCell align="center" width="10%">
                  Currency
                </TableCell>

                {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                <TableCell align="center" width="10%"></TableCell>
              </TableRow>
              {rows?.map((data, index) => {
                return (
                  <TableBody key={index}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="center">
                      {/* <FormControl fullWidth>
                        <InputLabel>Charge</InputLabel>
                        <Select
                          label="Charge"
                          value={data?.CostId || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            const io = rows?.map((v) => {
                              v.CostId =
                                v?.id === data?.id ? e.target.value : v?.CostId;
                              v.Cost =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value) : v?.Cost;
                              v.CostPrice =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CostPrice : +v?.CostPrice;
                              v.CurrencyId =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CurrencyId : v?.CurrencyId;

                              return v;
                            });

                            setRows([...io]);
                          }}
                        >
                          {MasterCost?.map((x) =>
                            <MenuItem value={x?.CostId}>{x?.CostName}</MenuItem>
                          )}
                        </Select>
                      </FormControl> */}
                      <Autocomplete
                        // freeSolo
                        fullWidth
                        options={MasterCost}
                        getOptionLabel={(option) => option?.CostName}
                        // renderOption={(props, option) => (
                        //   <Box component="li" {...props} key={option.EmpNo}>
                        //     {option?.firstname} {option?.lastname}</Box>
                        // )}

                        id="controlled-demo"
                        value={data?.Cost}
                        onChange={(event, newValue) => {
                          const io = rows?.map((v) => {
                            v.Cost = v?.id === data?.id ? newValue : v?.Cost;
                            v.CostId =
                              v?.id === data?.id ? newValue?.CostId : v?.CostId;
                            v.Cost =
                              v?.id === data?.id
                                ? MasterCost.find(
                                    (x) => x?.CostId === newValue?.CostId
                                  )
                                : v?.Cost;
                            v.CostPrice =
                              v?.id === data?.id
                                ? MasterCost.find(
                                    (x) => x?.CostId === newValue?.CostId
                                  )?.CostPrice
                                : +v?.CostPrice;
                            v.CurrencyId =
                              v?.id === data?.id
                                ? MasterCost.find(
                                    (x) => x?.CostId === newValue?.CostId
                                  )?.CurrencyId
                                : v?.CurrencyId;

                            return v;
                          });

                          setRows([...io]);
                        }}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        renderInput={(params) => (
                          <TextField {...params} label="Charge" />
                        )}
                      />
                    </TableCell>

                    <TableCell align="center">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={data?.CostPerContainer || ""}
                            onChange={(e) => {
                              const io = rows?.map((v) => {
                                v.CostPerContainer =
                                  v?.id === data?.id
                                    ? e.target.checked
                                    : v?.CostPerContainer;

                                return v;
                              });

                              setRows([...io]);
                            }}
                          />
                        }
                        label="per CNTR"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <TextField
                        label="Price"
                        value={data?.CostPrice || ""}
                        type="number"
                        onChange={(e) => {
                          const io = rows?.map((v) => {
                            v.CostPrice =
                              v?.id === data?.id
                                ? +e.target.value
                                : +v?.CostPrice;

                            return v;
                          });

                          setRows([...io]);
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <FormControl fullWidth>
                        <InputLabel>Currency</InputLabel>
                        <Select
                          label="Currency"
                          value={data?.CurrencyId || ""}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            const io = rows?.map((v) => {
                              v.CurrencyId =
                                v?.id === data?.id
                                  ? e.target.value
                                  : v?.CurrencyId;

                              return v;
                            });

                            setRows([...io]);
                          }}
                        >
                          {currency?.map((x) => (
                            <MenuItem value={x?.CurrencyId}>
                              {x?.CurrencyCode}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>

                    <TableCell align="center">
                      <Button
                        type="button"
                        variant="outlined"
                        style={{
                          color: "#80c340",
                          borderColor: "#80c340",
                        }}
                        onClick={() => deletehand(index)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableBody>
                );
              })}
            </Table>
          </TableContainer>
          <Button
            type="button"
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={history.goBack}
          >
            back
          </Button>
          <Button
            type="submit"
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            disabled={Submitting}
          >
            {Submitting && <CircularProgress size={22} />}
            {!Submitting && "SAVE"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
